import { Link } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { Check } from "lucide-react";

const FEATURES = [
  "Full weekly Reveal — all signals, commercial analysis, and calibrated actions",
  "Monthly deep Reveal — the full account thesis, refreshed monthly",
  "Exception Flashes — immediate alerts when something material breaks at the account",
  "Annual Account Compendium (when available)",
];

export default function UpgradePage() {
  return (
    <div className="min-h-screen bg-zinc-100" data-testid="upgrade-page">
      <header className="border-b border-zinc-200 bg-white">
        <div className="max-w-6xl mx-auto px-6 py-4 flex items-center justify-between">
          <Link to="/" className="text-xl font-semibold tracking-tight text-zinc-950 font-heading">
            Kalib AI
          </Link>
          <Link to="/intelligence" className="text-sm text-zinc-900 hover:text-zinc-950 transition-colors" data-testid="back-to-reveal-link">
            Back to Reveal
          </Link>
        </div>
      </header>

      <div className="max-w-lg mx-auto px-6 py-16">
        <h1 className="text-2xl sm:text-3xl font-medium tracking-tight text-zinc-950 font-heading mb-2">
          Unlock the full Reveal
        </h1>
        <p className="text-sm text-zinc-900 mb-8">
          Everything you need to sell smarter into this account. One subscription. No noise.
        </p>

        <div className="bg-white border border-zinc-200 p-6 mb-8" data-testid="upgrade-card">
          <div className="flex items-baseline gap-1 mb-6">
            <span className="text-3xl font-medium text-zinc-950 font-heading">$19</span>
            <span className="text-sm text-zinc-900">/ month</span>
          </div>

          <ul className="space-y-3 mb-8">
            {FEATURES.map((f, i) => (
              <li key={i} className="flex items-start gap-3">
                <Check className="w-4 h-4 text-amber-700 mt-0.5 flex-shrink-0" strokeWidth={2} />
                <span className="text-sm text-zinc-700">{f}</span>
              </li>
            ))}
          </ul>

          <Button
            className="w-full bg-zinc-200 text-zinc-900 rounded-none text-sm font-medium h-10 cursor-not-allowed"
            disabled
            data-testid="subscribe-btn"
          >
            Subscribe now — coming soon
          </Button>
          <p className="text-xs text-zinc-900 mt-3 text-center">
            Stripe integration coming soon. For early access, get in touch.
          </p>
        </div>

        <div className="text-center">
          <a
            href="mailto:hello@kalib.ai"
            className="text-sm text-amber-700 hover:text-amber-800 font-medium"
            data-testid="waitlist-link"
          >
            Join the waitlist / Get in touch
          </a>
        </div>
      </div>
    </div>
  );
}
